import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';

export const TILE_TITLE_HEIGHT = 36;

const styles = StyleSheet.create({
    container: {
        marginTop: 4,
        height: 36,
        width: '100%',
        justifyContent: 'flex-start',
        overflow: 'hidden',
    },
    loadingContainer: {
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 32,
        width: 120,
    },
    title: {
        fontFamily: Fonts.main.bold,
        fontSize: 14,
        color: COLOR.NEUTRAL,
        lineHeight: 19.6,
    },
    subTitle: {
        fontFamily: Fonts.main.regular,
        fontSize: 12,
        color: lightGrey(0.7),
        lineHeight: 15.6,
    },
    alignCenter: {
        textAlign: 'center',
    },
    loadingText: { color: 'transparent' },
});

export default styles;
